import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { colors, gutterWidth } from 'theme';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { CmsAmpRecommendedActionsBlockActions } from './CmsAmpRecommendedActionsBlockActions';

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsAmpRecommendedActionsBlock({
  data: { headline, volopFunction, areaOfFocus },
}: Props) {
  return (
    <Box
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      p={[gutterWidth / 2, null, gutterWidth]}
      borderRadius={[0, null, null, 48]}
      bg={colors.backgroundGrey}
      textAlign="center"
    >
      {headline && <RichTextHeadline>{headline}</RichTextHeadline>}

      <AnchorButton href={listingSearchHomePath('VOLOP')}>
        {getText('See All')}
      </AnchorButton>

      <Box mt={48}>
        <CmsAmpRecommendedActionsBlockActions
          volopFunction={volopFunction}
          areaOfFocus={areaOfFocus}
        />
      </Box>
    </Box>
  );
}
